module.exports = __webpack_public_path__ + "static/freewrite2-3a637c25c81e168eedd706663d4f2657.jpg";